var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnergyWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1401_14959)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7835 1.71812C10.8145 1.57263 10.7966 1.42097 10.7326 1.2867C10.6685 1.15244 10.5619 1.0431 10.4293 0.975669C10.2967 0.908241 10.1456 0.886504 9.99933 0.913837C9.8531 0.94117 9.72 1.01604 9.62071 1.12682L1.97071 9.67682C1.88384 9.77394 1.82694 9.89413 1.80688 10.0229C1.78681 10.1516 1.80444 10.2834 1.85764 10.4024C1.91083 10.5213 1.99732 10.6223 2.10666 10.6932C2.21599 10.7641 2.34351 10.8018 2.47381 10.8018H8.38861L7.21411 16.2855C7.18309 16.431 7.201 16.5827 7.26505 16.7169C7.3291 16.8512 7.43571 16.9605 7.56831 17.028C7.70091 17.0954 7.85207 17.1171 7.9983 17.0898C8.14452 17.0625 8.27762 16.9876 8.37691 16.8768L16.0269 8.32682C16.1138 8.22969 16.1707 8.10951 16.1907 7.98076C16.2108 7.85201 16.1932 7.72021 16.14 7.60126C16.0868 7.48231 16.0003 7.3813 15.891 7.31042C15.7816 7.23954 15.6541 7.20182 15.5238 7.20182H9.60901L10.7835 1.71812Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1401_14959"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.00195312)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergyWhite);
export default __webpack_public_path__ + "static/media/energyWhite.e6151133cf6f76c5d0b29ce18d16b680.svg";
export { ForwardRef as ReactComponent };